import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import TR from './../../Trans';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import AlbumIcon from '@mui/icons-material/Album';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import sessionStore from '../../stores/session';
import singersStore from '../../stores/singers';
import accountStore from '../../stores/account';
import bgPerformanceStore from '../../stores/bgPerformance';

function BackgroundHistoryListItem(props) {

  const thisPerformance = bgPerformanceStore((state) => state.history?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const deletePerformanceFromHistory = bgPerformanceStore((state) => state.deletePerformanceFromHistory);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  const timeDiff = accountStore((state) => state.timeDiff);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!singers) {
      getSingers(sessionToken);
    }
  }, []);

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const getLength = (track) => {
    if (track) {
      return lengthToMinutes(track.length);
    }
    return "";
  };

  const renderDelete = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      handleMenuClose();
      console.log("search", thisPerformance, thisPerformance?.unique_id);
      deletePerformanceFromHistory(sessionToken, thisPerformance?.unique_id);
    }}>{TR.cm_delete}</MenuItem>;
  };

  const primaryText = () => {
    return <div>
      {thisPerformance?.track.title}
    </div>;
  };

  const secondaryText = thisPerformance?.track.artist;

  const renderPlayed = () => {
    if (thisPerformance?.played) {
      let date = new Date(thisPerformance?.played);
      date.setMinutes(date.getMinutes() - timeDiff);
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
    }
  };

  const renderListItem = () => {
    if (thisPerformance) {
      return <ListItemButton sx={{
        lineHeight: 0.9,
        paddingLeft: "0.75rem !important",
        margin: 0,
        bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08)' : 'unset'
      }}
        onClick={(e) => props.onAddBackgroundMusic(e, thisPerformance)}
      >
        <ListItemText className="muvika-list-left" primary={renderPlayed()} />
        <ListItemText primary={primaryText()} secondary={secondaryText} />
        <ListItemText
          className="muvika-list-right"
          primary={getLength(thisPerformance?.track)}
          secondary={thisPerformance?.track.kcode}
        />
        <IconButton
          id={"music-history-menu-button-" + thisPerformance?.unique_id}
          color="white"
          component="label"
          size="small"
          aria-controls={isMenuOpen ? "music-history-menu-" + thisPerformance?.unique_id : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={(e) => {

            e.stopPropagation();
            openMenu(e);
          }}>
          <MenuIcon />
        </IconButton>
        <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
          id={"music-history-menu-" + thisPerformance?.unique_id}
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={(e) => {

            e.stopPropagation();
            handleMenuClose();
          }}
          MenuListProps={{
            'aria-labelledby': 'music-history-menu-button-' + thisPerformance?.unique_id,
          }}
        >
          {renderDelete()}
        </Menu>
      </ListItemButton>;
    }
  };

  return (
    <div>
      {renderListItem()}
    </div>
  );
}

export default BackgroundHistoryListItem;